import React from 'react';

export const SummaryHeaderItem = ({ amount, label }) => (
  <div className="text-center flex-1">
    <p className="text-white text-2xl font-bold">{amount}</p>
    <p className="text-gray-200 text-sm">{label}</p>
  </div>
);
